import { css } from 'emotion';

const hiddenContainer = css`
  display: none;
`;

export const MicroFrontendV2Styles = { hiddenContainer };
